import { IonContent, IonPage, IonText, useIonViewWillEnter } from '@ionic/react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import React, { useContext, useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { DetailContent, StyleIonHeader, TextStyle } from '../../../components'
import { DivideLine } from '../../../components/atoms/divide'
import { StoresContext } from '../../../provider/StoreProvider'

type Props = RouteComponentProps<{
  eventId: string
}>

export const DetailEvent: React.FC<Props> = observer(({ match }) => {
  const { commonStore, artfairStore } = useContext(StoresContext)
  let loadParam = { eventId: Number(match.params.eventId) }
  const detailStore = artfairStore.eventDetailStore

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  useEffect(() => {
    loadParam = { eventId: Number(match.params.eventId) }
    detailStore.load({ param: loadParam })
  }, [match.params.eventId])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={''} href={'/artfair'} />
      <HeaderContainer>
        {detailStore.isLoaded && (
          <>
            <TextStyle type={'b_16'}>{detailStore.content?.title}</TextStyle>
            <TextStyle type={'r_11'} color={'gray400'}>
              {moment(new Date(detailStore.content?.createdDate ?? '0000-00-00T00:00:00.000Z')).format(
                'MM월 DD일 HH시 MM분',
              )}
            </TextStyle>
          </>
        )}
      </HeaderContainer>
      <DivideLine />
      <IonContent>
        <DetailContent detailStore={detailStore}>
          <>
            <ImgWrap>
              <img
                src={detailStore.content?.imageUri}
                alt={detailStore.content?.title}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
            </ImgWrap>
            <ContentContainer>
              {detailStore.content?.contents?.map((d, i) => (
                <CategoryWrap key={i}>
                  {d.type === 'header' && <IonText className={'category-title'}>{d.content ?? '-'}</IonText>}
                  {d.type === 'body' && <IonText className={'category-content'}>{d.content ?? '-'}</IonText>}
                  {d.type === 'image' && (
                    <img
                      src={d.content}
                      alt={detailStore.content?.title}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null
                        currentTarget.src = '/img/thumbnail.svg'
                      }}
                    />
                  )}
                </CategoryWrap>
              ))}
            </ContentContainer>
          </>
        </DetailContent>
      </IonContent>
    </IonPage>
  )
})

const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
`

const ImgWrap = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  img {
    object-fit: contain;
  }
`

const ContentContainer = styled.div`
  padding: 0 20px 20px 20px;
`

const CategoryWrap = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  .category-title {
    font-weight: 900;
    font-size: 20px;
    margin: 20px 0;
  }
  .category-content {
    font-size: 15px;
    margin-bottom: 20px;
  }
`
